import { useEffect, useState } from "react";
import { GetWfsResponseTimeRequest } from "../../../types/WfsLog/GetWfsResponseTimeRequest";
import { ResponseTimeGranularity } from "../../../constant/ResponseTimeGranularity";
import { User } from "../../../types/User";
import { ResponseTimes } from "../../../types/WfsLog/ResponseTimes";
import GetWfsResponseTimeRequestService from "../../../services/GetWfsResponseTimeRequestService";
import { DateTime } from "luxon";
import RequestStatisticsGraph from "./Graph";
import RequestStatisticFilters from "./Filters";
import { useWfsLogService } from "../../../hooks";

const RequestStatistics = () => {
  const wfsLogService = useWfsLogService();
  const getWfsResponseTimeRequestService =
    new GetWfsResponseTimeRequestService();

  const [filterRequest, setFilterRequest] = useState<GetWfsResponseTimeRequest>(
    getWfsResponseTimeRequestService.getDefaultRequest(),
  );

  const [selectedUser, setSelectedUser] = useState<User | undefined>();

  const [granularity, setGranularity] =
    useState<ResponseTimeGranularity | null>();

  const [responseTimes, setResponseTimes] = useState<ResponseTimes>();

  useEffect(() => {
    wfsLogService
      .getWfsResponseTimes(filterRequest)
      .then(setResponseTimes)
      .catch(() => {});
  }, [filterRequest]);

  useEffect(() => {
    if (!granularity) return;
    setFilterRequest(
      getWfsResponseTimeRequestService.getDefaultRequest(
        granularity,
        filterRequest,
      ),
    );
  }, [granularity]);

  const onChange = (e: React.ChangeEvent<any>) => {
    const { name, value, type } = e.target;
    if (type == "date") {
      const now = DateTime.now();
      const date = DateTime.fromISO(value);
      setFilterRequest((prevFilterRequest) => ({
        ...prevFilterRequest,
        [name]: date.hasSame(now, "day") ? now : date,
      }));
    } else if (type == "datetime-local") {
      const date = DateTime.fromISO(value);
      setFilterRequest((prevFilterRequest) => ({
        ...prevFilterRequest,
        [name]: date,
      }));
    } else {
      setFilterRequest((prevFilterRequest) => ({
        ...prevFilterRequest,
        [name]: value,
      }));
    }
  };

  return (
    <>
      <RequestStatisticFilters
        filterRequest={filterRequest}
        setFilterRequest={setFilterRequest}
        setSelectedUser={setSelectedUser}
        selectedUser={selectedUser}
        getWfsResponseTimeRequestService={getWfsResponseTimeRequestService}
        setGranularity={setGranularity}
        onChange={onChange}
      />
      <hr />
      <RequestStatisticsGraph
        filterRequest={filterRequest}
        responseTimes={responseTimes}
        getWfsResponseTimeRequestService={getWfsResponseTimeRequestService}
      />
    </>
  );
};

export default RequestStatistics;
